<!-- <div class="btn btn-primary" (click)="add()" style="cursor: pointer;">Add department</div> -->
<table class="table">
    <thead>
      <tr>
        <th scope="col">Name</th>
        <!-- <th scope="col">Action</th> -->
      </tr>
    </thead>
    <tbody>
<tr *ngFor="let item of departments[0]">
    <td>{{item.name}}</td>
    <!-- <td>
        <div class="btn btn-primary" (click)="edit(item.id)" style="cursor: pointer;">Edit</div>
    </td> -->
</tr>
</tbody>
</table>